import {Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, signal} from '@angular/core';
import {ToolbarAction} from '../../core/definitions/toolbar-action';
import {OperationToolbarServiceService} from '../operation-toolbar-service.service';
import {OperationContainer} from '../../core/definitions/operation-container';
import {OperationStepExecutionResult} from '../../core/definitions/operation-step-execution-result';
import {OperationStep} from "../../core/definitions/operation-step";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "../../object-edit/confirm-dialog/confirm-dialog.component";
import {OperationStepType} from "../../core/definitions/operation-step-type.enum";

@Component({
    selector: 'app-operation-toolbar-dialog',
    templateUrl: './operation-toolbar-dialog.component.html',
    styleUrls: ['./operation-toolbar-dialog.component.scss'],
    standalone: false
})
export class OperationToolbarDialogComponent implements OnChanges, OnDestroy {
  // Injections
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly operationToolbarService: OperationToolbarServiceService = inject(OperationToolbarServiceService);

  @Input() hasPackageObjects: boolean;
  @Input() operationContainer: OperationContainer;
  @Input() operationStep: OperationStep;
  @Input() selectorEnabled: boolean;
  @Input() stylingClass: string;
  @Output() operationStepExecutionResult = new EventEmitter<OperationStepExecutionResult>();

  toolbarActions: ToolbarAction[] = [];
  private registerHasBeenRun = false;
  private lastOperationStepExecutionResult: OperationStepExecutionResult;

  showValidation = signal(true);
  showStepIndicator = signal(true);

  ngOnChanges(): void {
    this.toolbarActions = this.operationStep.toolbar_actions || [];

    if (this.operationContainer.currentOperation.$$currentStep.operation_step_type === OperationStepType.EDIT_SELECTED_COPY) {
      this.showValidation.set(false);
      this.showStepIndicator.set(false);
    }
  }

  ngOnDestroy() {
    this.operationToolbarService.clearScrollTimeout();
  }

  get isInvalid(): boolean {
    return this.operationToolbarService.getIsInvalid(this.operationContainer, this.registerHasBeenRun);
  }

  getTooltipText(action: ToolbarAction) {
    return this.operationToolbarService.getTooltipText(this.selectorEnabled, action);
  }

  isDisabled(action: ToolbarAction): boolean {
    return this.operationToolbarService.isDisabled(this.operationContainer, action, this.registerHasBeenRun);
  }

  get isCompleted(): boolean {
    return this.operationToolbarService.isCompleted(this.operationContainer);
  }

  async checkRunAction(action: ToolbarAction) {
    if (action.action_type === 'register' && this.hasPackageObjects) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          modalTitle: 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING__DIALOG_TITLE',
          modalContent: 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING__DIALOG_CONTENT',
          modalCancel: 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING__DIALOG_CANCEL',
          modalConfirm: 'TRANS__OPERATIONS__LOCATION_PACKAGE__WARNING__DIALOG_CONFIRM'
        }
      });

      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.runAction(action).then();
        }
      });
    }
    else {
      this.runAction(action).then();
    }
  }

  get errorCount() {
    return this.operationToolbarService.getErrorCount(this.operationContainer);
  }

  private async runAction(action: ToolbarAction) {
    const runActionResult = await this.operationToolbarService.runAction(
      this.operationContainer, action, false, this.lastOperationStepExecutionResult);
    this.registerHasBeenRun = runActionResult.registerHasBeenRun;
    this.lastOperationStepExecutionResult = runActionResult.operationStepExecutionResult;
    this.operationStepExecutionResult.emit(runActionResult.operationStepExecutionResult);
  }
}
